import { Injectable } from '@angular/core';
import { Notificacion } from '../models/notificacion.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

/**
 * Rest-Service que trabaja con las notificaciones. Permite:
 *
 * Obtener notificaciones
 * Actualizar su estado (Leída / No Leída)
 */
@Injectable({ providedIn: 'root' })
export class NotificacionesRestService {
  constructor(private httpClient: HttpClient) { }

  obtenerNotificaciones() {
    return this.httpClient.get<Notificacion[]>(
      environment.apiURL + 'v1/notificaciones'
    );
  }

  contarNotificacionesNoLeidas(): Observable<number> {
    return this.httpClient.get<number>(environment.apiURL + 'v1/notificaciones/contarNotificacionesNoLeidas');
  }

  actualizarLecturaNotificacion(notificacion: Notificacion) {
    return this.httpClient.post<Notificacion>(
      environment.apiURL + 'v1/notificaciones/' + notificacion.id + '/actualizar-marca-lectura',
      { marcaLectura: notificacion.leida }
    );
  }

  obtenerNotificacion(idNotificacion: number) {
    return this.httpClient.get<Notificacion>(
      environment.apiURL + 'v1/notificaciones/' + idNotificacion
    );
  }
}
